import { render, staticRenderFns } from "./addaward.vue?vue&type=template&id=639146eb&"
import script from "./addaward.vue?vue&type=script&lang=js&"
export * from "./addaward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports